const appConfig = {
  "baseUrl": "https://global.api-test.mit.edu",
  "paths": {
    "apiPathCommencement": "commencement-public/v1"
  },
  "recaptchaSiteKey": "6LdaAZAqAAAAAIjvxxWkO9UJe-LgxQW5aHB8QlcS"
};
export default appConfig;